import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { AlertOctagon, ArrowRight } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

export default function SelfTest() {
  const { t } = useLanguage();
  return (
    <section
      id="selftest"
      data-testid="selftest-section"
      className="relative py-24 md:py-32 overflow-hidden"
      style={{ background: "#0A0A0A" }}
    >
      <div
        aria-hidden="true"
        className="hero-mark right-[-2%] -top-10 text-[55vh] hidden md:block"
      >
        ?
      </div>

      <div className="max-w-7xl mx-auto px-5 lg:px-10 relative">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="relative border border-white/10 bg-[#0F0F0F] p-8 md:p-14 noise-overlay"
        >
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
            <div className="lg:col-span-8">
              <p className="overline">{t.selftest.overline}</p>
              <h2 className="font-display uppercase mt-4 text-3xl md:text-4xl lg:text-5xl leading-[1] tracking-tight">
                {t.selftest.title}
              </h2>
              <p className="mt-5 text-base md:text-lg text-white/65 max-w-2xl">
                {t.selftest.subtitle}
              </p>
              <div className="mt-3 font-mono-plex text-[11px] uppercase tracking-widest text-white/40">
                {t.selftest.note}
              </div>
            </div>

            <div className="lg:col-span-4 flex lg:justify-end">
              <Link
                to="/selbsttest"
                data-testid="selftest-cta"
                className="btn-primary inline-flex items-center gap-3 px-7 py-5 text-sm font-medium uppercase tracking-wide w-full lg:w-auto justify-center"
              >
                <AlertOctagon size={20} />
                {t.selftest.cta}
                <ArrowRight size={18} />
              </Link>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
